import axios from '../utils/axios';
import { API_URL_CLIENTS } from '../constants';

const assignCodeReferred = async(data) => {
    const response = await axios.post(`${API_URL_CLIENTS}/client/assign_code`, data)
    return response.data
}

export default assignCodeReferred;